// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_kT5","cls2":"WorkCard-cls2_0_V WorkCard-cls1_kT5"};